import { createNamespacedHelpers } from 'vuex';

import namespacedLog from '@/store/utils/namespacedLog';

// Root module
const namespace = ['companyFiles'];

export const actionLog = (name, message, error) => namespacedLog('Action', namespace, name, message, error);

export const mutationLog = (name, message, error) => namespacedLog('Mutation', namespace, name, message, error);

export const apiLog = (name, message, error) => namespacedLog('API', namespace, name, message, error);

const { mapActions, mapGetters } = createNamespacedHelpers(namespace.join('/'));

export const mapCompanyFilesActions = mapActions;

export const mapCompanyFilesGetters = mapGetters;

export default namespace;



// WEBPACK FOOTER //
// ./src/store/companyFiles/namespace.js